import React from 'react'
import Chart from 'react-apexcharts';
import { darken, desaturate, lighten, saturate } from 'polished';
import BarSkelitonLoader from '../../loader/BarSkelitonLoader';

const SingleReportGraph = ({ isVisible, singleData, handleClickInnerGraph, handleClickInnerData, singleColor }) => {


    const options = {

        dataLabels: {
            enabled: true,
            style: {
                colors: ['black']
            },
            dropShadow: {
                enabled: false,
                enabledOnSeries: undefined,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.35
            }
        },
        fill: {
            type: 'gradient',
        },
        chart: {
            id: 'basic-bar',
            toolbar: {
                show: false
            },
            fontFamily: 'Open Sans',
            events: {
                click: handleClickInnerGraph,
                dataPointSelection: handleClickInnerData
            }
        },
        grid: {
            borderColor: '#E4E4E4',
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
        },
        plotOptions: {
            bar: {
                distributed: true,
                columnWidth: '40px'
            },
        },
        legend: {
            show: false
        },

        colors: [darken(0.1, singleColor), singleColor, lighten(0.1, singleColor), desaturate(0.2, singleColor)],
        xaxis: {
            categories: ['Payment 835', 'Payment 835 Lite', 'Patient Pay', 'Correspondence'],
            axisBorder: {
                show: true,
                color: '#000000',
                height: 1,
                width: '100%',
                offsetX: 0,
                offsetY: 0
            },
            labels: {
                show: true,

            }

        },
        yaxis: {
            axisBorder: {
                show: true,
                color: '#000000',
                height: '100%',
                width: 1,
                offsetX: 0,
                offsetY: 0
            },

        },
        tooltip: {
            show: true,
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const color = w.config.colors[dataPointIndex];
                console.log(w)
                let tooltip = ''
                const mainLabel = w.globals.labels[dataPointIndex]
                if (mainLabel === "Payment 835") {
                    tooltip = `${mainLabel}:${singleData?.payment835_claims}/${singleData?.payment835_job_count}`
                }
                else if (mainLabel === "Payment 835 Lite") {
                    tooltip = `${mainLabel}:${singleData?.payment835lite_claims}/${singleData?.payment835lite_job_count}`
                }
                else if (mainLabel === "Patient Pay") {
                    tooltip = `${mainLabel}:${singleData?.patientpay_claims}/${singleData?.patientpay_job_count}`
                }
                else if (mainLabel === "Correspondence") {
                    tooltip = `${mainLabel}:${singleData?.correspondence_claims}/${singleData?.correspondence_job_count}`
                }
                return `<div style="background-color:${color};padding:5px" class="">
                        <span style="color:black;"> ${tooltip}  </span>
                </div>`

            }
        },
    };
    const series_items = [singleData?.payment835_claims, singleData?.payment835lite_claims, singleData?.patientpay_claims, singleData?.correspondence_claims]

    const series = [{
        name: '',
        data: series_items ? series_items : []
    }]
    console.log(series)
    return (
        <div className='card p-2' style={{ height: '45vh' }}>
            {isVisible ?
                <BarSkelitonLoader /> :
                <Chart options={options} series={series} type="bar" height={'90%'} />}
        </div>
    )
}

export default SingleReportGraph